<template>
    <div>
        <v-data-table :headers="colunas" :items="resultadoTabela" class="elevation-1" :footer-props="dataFooter"
            :custom-sort="sortDataTable" group-by="group" sort-by="dataRetornoPPA">
            <template v-slot:[`group.header`]="group">
                <td colspan="11">    
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon @click="group.toggle" :color="themes.primary" v-on="on">
                                {{ group.isOpen ? 'mdi-minus' : 'mdi-plus' }}
                            </v-icon>                                   
                        </template>

                        <span v-show="group.isOpen">{{$t("Views.Onboarding.Log.Listar.retrair-agrupamento")}}</span>
                        <span v-show="!group.isOpen">{{$t("Views.Onboarding.Log.Listar.expandir-agrupamento")}}</span>
                    </v-tooltip>   

                    <span @click="group.toggle">
                        {{`Retorno PPA ${$moment.utc(group.items[0].dataRetornoPPA).local().format("DD/MM/YYYY")}`}}  
                    </span>                                                                        
                </td>
            </template>    

            <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.status == 0">{{$t("Views.Onboarding.Log.Listar.aguardando-processamento")}}</span>
                <span v-else-if="item.status == 1">{{$t("Views.Onboarding.Log.Listar.processado-sucesso")}}</span>
                <span v-else-if="item.status == 2">{{$t("Views.Onboarding.Log.Listar.processado-com-erro")}}</span>
                <span v-else-if="item.status == 3">{{$t("Views.Onboarding.Log.Listar.em-processamento")}}</span>
            </template>       

            <template v-slot:[`item.dataRetornoPPA`]="{ item }">
                {{formatUtcToLocal(item.dataRetornoPPA)}}                              
            </template>       

            <template v-slot:[`item.informacoes`]="{ item }">
                <v-icon v-show="item.processamento != null" :color="themes.primary" @click="openInformation(item)">mdi-information</v-icon>    
            </template>   

            <template v-slot:[`item.tempo`]="{ item }">
                {{getTimespan(item.dataInicio, item.dataTermino)}}              
            </template>   

            <template v-slot:[`item.dataInicio`]="{ item }">
                {{formatUtcToLocal(item.dataInicio)}}                              
            </template>                         

            <template v-slot:no-data>{{nenhumColaboradorEncontrado}}</template>

            <template v-slot>{{realziarPesquisa}}</template>     
        </v-data-table>

        <information-dialog v-model="showInformation" maxWidth="590px" :title="$t('Views.Onboarding.Log.Listar.informacoes-processamento')">
            <v-container fill-height fluid grid-list-xl>
                <v-layout wrap v-if="registroSelecionado != null && registroSelecionado.processamento != null">
                    <v-flex sm12 xs12 md12 lg12 grid-list-md>
                        <v-flex>{{`Id Workspace: ${registroSelecionado.processamento.onboardingPais.id}`}}</v-flex>

                        <v-expansion-panels>
                            <v-expansion-panel v-for="passo in registroSelecionado.processamento.passos" :key="passo.id">
                                <v-expansion-panel-header >
                                    <template v-slot:actions>
                                        <v-icon v-if="!errosPasso(passo)" color="success">
                                            mdi-check-bold
                                        </v-icon>
                                        <v-icon v-else color="error">
                                            mdi-close-circle
                                        </v-icon>            
                                    </template>

                                    {{tituloPasso(passo)}}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                <v-list dense>  
                                    <template v-if="passo.log != null && passo.log.length > 0">
                                        <v-list-item v-for="log in passo.log" :key="log.id">
                                            <v-list-item-content>
                                                <v-flex sm12 xs12 md12 lg12>
                                                    {{log.mensagem}}                          
                                                </v-flex>         
                                            </v-list-item-content>
                                        </v-list-item>  
                                    </template>    
                                    <template v-else>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-flex sm12 xs12 md12 lg12>
                                                    {{$t('Views.Onboarding.Log.Listar.passo-processado-com-sucesso')}}
                                                </v-flex>        
                                            </v-list-item-content>
                                        </v-list-item>                                         
                                    </template>                   
                                </v-list>   
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>                  
                    </v-flex>
                </v-layout>
            </v-container>
        </information-dialog> 
    </div>  
</template>

<script>
    import DateMixin from '@/mixin/date'
    import FormMixin from '@/mixin/form'
    import LogIntegracaoApi from '@/api/integracao-success-factors/onboarding/log-ppa'
    import InformationDialog from '@/components/material/InformationDialog'
    import PaisConstantes from '@/constants/corporativo/pais'

    export default {
    mixins: [ DateMixin, FormMixin], 
    props: {
        value:{
            type: Object,
            required: false
        }
    }, 
    components: {
        "information-dialog": InformationDialog,
    },  
    watch:{
        async value(){           
            await this.consultarLog();
        }
    },
    data () {
        return { 
            resultado: [],
            colunas: [
                { text: this.$t("Views.Onboarding.Log.Listar.job-req-id"), align: 'center', value: 'codigoVaga' },
                { text: this.$t("Views.Onboarding.Log.Listar.data-retorno-ppa"), align: 'center', value: 'dataRetornoPPA' },                
                { text: this.$t("Views.Onboarding.Log.Listar.colaborador"), align: 'left', value: 'nome' },
                { text: this.$t("Views.Onboarding.Log.Listar.codigo-sf"), align: 'center', value: 'usuarioSF' },
                { text: this.$t("Views.Onboarding.Log.Listar.indicador-sucesso"), align: 'center', value: 'status' },
                { text: this.$t("Views.Onboarding.Log.Listar.data-inicio"), align: 'center', value: 'dataInicio' },                
                { text: this.$t("Views.Onboarding.Log.Listar.tempo-processamento"), align: 'center', value: 'tempo' },              
                { align: 'center', value: 'informacoes' },
            ],
            showInformation: false,
            registroSelecionado: null,
        }
    },
    computed: {
        nenhumColaboradorEncontrado(){
            return this.$t("Views.Onboarding.Log.Listar.nenhum-colaborador-encontrado");
        },
        labelIndicadorSucesso(){
            return this.$t("Views.Onboarding.Log.Listar.indicador-sucesso");
        },
        labelVagaAprovada(){
            return this.$t("Views.Onboarding.Log.Listar.vaga-aprovada");
        },
        labelIndicadorErro(){
            return this.$t("Views.Onboarding.Log.Listar.indicador-erro");
        },
        resultadoTabela(){
            return this.resultado || [];
        },
    },
    mounted(){
        this.consultarLog();
    },
    methods:{   
        errosPasso(passo){
            return passo.log.filter(
                l => l.classificacaoLog == 'ERRO'
            ).length > 0;
        },
        tituloPasso(passo){
            let titulo = "";
            if(passo == null)
                return titulo;

            switch(passo.entidade)
            {
                case "User":
                    titulo = "Usuário";
                    break;

                case "PerPerson":
                    titulo = "Informações pessoais (Informações biográficas)";
                    break;       
                    
                case "EmpEmployment":
                    titulo = "Informações de emprego (Detalhes do emprego)";
                    break;           
                    
                case "EmpJob":
                    titulo = "Informações de emprego (Informações do cargo)";
                    break;   
                    
                case "PerPersonal":
                    titulo = "Informações pessoais (Informações pessoais)";
                    break;   
                    
                case "PerNationalId":
                    titulo = "Informações pessoais (Nº do documento de identificação)";
                    break;   
                    
                case "Cust_NationalIDBRA":
                    titulo = "Informações pessoais (Nº do documento de identificação)";
                    break;   
                    
                case "PerEmail":
                    titulo = "Informações pessoais (Informação de Contato :: E-mail)";
                    break;   
                    
                case "PerPhone":
                    titulo = "Informações pessoais (Informação de Contato :: Telefone)";
                    break;                       
                    
                case "PerAddressDEFLT":
                    titulo = "Informações pessoais (Informações de endereço)";
                    break;                       
                    
                case "PerGlobalInfoBRA":
                    titulo = "Informações pessoais (Informações gerais)";
                    break;                       
                    
                case "EmpJobRelationships":
                    titulo = "Informações de emprego (Relações de trabalho)";
                    break;                       
                    
                case "EmpCompensation":
                    titulo = "Informações de emprego (Detalhes do emprego)";
                    break;   

                case "EmpPayCompRecurring":
                    titulo = "Informações de emprego (Informações de compensação)";
                    break;                       
                    
                case "PaymentInformationV3":
                    titulo = "Informações pessoais (Informação de pagamento: 1)";
                    break; 
                    
                case "PaymentInformationDetailV3":
                    titulo = "Informações pessoais (Informação de pagamento: 2)";
                    break; 
                    
                case "PaymentInformationDetailV3BRA":
                    titulo = "Informações pessoais (Informação de pagamento: 3)";
                    break;                                         
                    
                case "Photo":
                    titulo = "Informações pessoais (Foto)";
                    break;   
                    
                case "JobApplication":                    
                    titulo = "Alteração de status SAP SF(contratado)";
                    break;            
                    
                case "PerPersonDep":
                    titulo = "Informações pessoais dependente (Informações biográficas)";
                    break;          
                    
                case "PerPersonRelationshipDep":
                    titulo = "Relação dependente x colaborador";
                    break;                      
                    
                case "PerPersonalDep":
                    titulo = "Informações pessoais dependente (Informações pessoais)";
                    break;            
                    
                case "PerGlobalInfoBRADep":
                    titulo = "Informações pessoais dependente (Informações gerais)";
                    break;         
                    
                case "PerNationalIdDep":
                    titulo = "Informações pessoais dependente (Nº do documento de identificação)";
                    break;                      
                                 
                default:
                    titulo = passo.entidade;
                    break;
            }    
            
            return titulo;
        },       
        openInformation(colaborador){
            this.showInformation = true;
            this.registroSelecionado = colaborador;
        },
        async consultarLog(){
            if(this.value == null || (this.value.pais != null && this.value.pais.codigoSuccessFactors != PaisConstantes.brasil.codigo)) {
                this.resultado = [];
                return;
            }

            const loading = this.showLoading();            
            const self = this;

            let log = await LogIntegracaoApi.listarLogPorDataIntegracao(
                self.tranformDate2Epoch(this.value.dataInicial),
                self.tranformDate2Epoch(this.value.dataFinal),
                this.value.pais.id,
                this.value.correlationId,
                this.value.jobReqId,            
                this.value.indicadorSucesso
            ).catch(erro => self.showSnackbarError(erro.error));
            
            if(log.success) {
                for(let index = 0; index < log.data.length; index++){
                    let element = log.data[index];
                    if(element.processamento == null || element.processamento.dataTermino == null){
                        element.tempo = 0;
                        element.dataTermino = null; 
                    }
                    else{
                        const startDate = self.$moment(element.processamento.dataInicio);
                        const endDate = self.$moment(element.processamento.dataTermino);

                        const difference = endDate.diff(startDate);                     
                        element.tempo = self.$_.parseInt(difference);
                        
                        element.dataInicio = self.$moment(element.processamento.dataInicio).toDate();  
                        element.dataTermino = self.$moment(element.processamento.dataTermino).toDate();                     
                    }

                    element.dataRetornoPPA = self.$moment(element.dataRetornoPPA).toDate();
                    element.usuarioSF = element.usuarioSF == 0 ? null : element.usuarioSF;
                    element.group = self.$moment.utc(element.dataRetornoPPA).format("DD/MM/YYYY");  
                }

                self.resultado = log.data;
            }
            else {                        
                self.showSnackbarError(log.error);
                throw new Error(log.error[0].userMessage);
            }                 

            loading.close(); 
        }        
    }  
}
</script>
